module.exports = __webpack_public_path__ + "themes/fq/img/frame-center.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/frame-center.png
// module id = 9
// module chunks = d-game